/*jslint browser: true */
/*global window */

(function($){
	$(document).ready(function(){
		$('.testimonial_slider').slick({
			arrows: true,
			dots: false,
			prevArrow: $('.testimonial-arrow_left'),
			nextArrow: $('.testimonial-arrow_right'),
		});
		$('.health_accreditations-slider').slick({
			dots: true,
			arrows: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			autoplay: true,
  			autoplaySpeed: 2500,
		});
	});
	
	$('.j_gang').on('change', function(){
		if($(this).val() == "Yes") {
			$('#j_gang_size').show();
		} else {
			$('#j_gang_size').hide();
		}
	});
	
	// $('#menu-item-332').on('hover', function(){
	// 	if($('#menu-item-332 .submenu').hasClass('active')) {
	// 		$('#menu-item-332 .submenu').removeClass('active');	
	// 	} else {
	// 		$('#menu-item-332 .submenu').addClass('active');
	// 	}
	// });

	$('#menu-item-384').hover(function(){
		$('#menu-item-384 .submenu').addClass('active')
	}, function(){
		$('#menu-item-384 .submenu').removeClass('active');
	});
})(jQuery);